import { render, staticRenderFns } from "./SettingScale.vue?vue&type=template&id=ad2f6608&scoped=true"
import script from "./SettingScale.vue?vue&type=script&lang=js"
export * from "./SettingScale.vue?vue&type=script&lang=js"
import style0 from "./SettingScale.vue?vue&type=style&index=0&id=ad2f6608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2f6608",
  null
  
)

export default component.exports